import { h } from "preact";
import { StoryDTO } from "../model/Item";
import { StoryList } from "./storyList";

interface ContainerProps {
    stories: StoryDTO[];
}

export const Container = (props: ContainerProps) => <div id="container" class="container"><main><StoryList stories={props.stories} /></main></div>;
